'use client'

import { SectionHeader } from '@/components/section-header'
import { StepCard } from './StepCard'

export const ThreeSteps = () => {
  return (
    <section className="w-full py-8 steps:py-16 px-4 steps:px-[120px]" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-[780px] steps:max-w-[1260px] mx-auto">
        {/* タイトルエリア */}
        <div className="mb-8 steps:mb-10">
          <SectionHeader
            title="ご利用は簡単3ステップ！"
            description="導入～送付まで簡単３ステップ、お問い合わせていただければサービス内容をご案内いたします。"
          />
        </div>

        {/* ステップカードエリア - SP: 縦並び、PC: 絶対配置 */}
        <div className="flex flex-col steps:relative gap-4 steps:gap-0" style={{ minHeight: '1200px' }}>
          {/* STEP1 */}
          <div className="steps:absolute steps:left-0 steps:top-0 w-full steps:w-[584px]">
            <StepCard stepNumber={1} title="会員登録" backgroundColor="#EBF7FC" showStepLabel>
              <div
                className="text-xs steps:text-base"
                style={{
                  fontWeight: 400,
                  letterSpacing: '0.64px',
                  lineHeight: '1.6',
                  color: '#363636',
                  marginBottom: '16px',
                }}
              >
                <p style={{ marginBottom: 0 }}>WEBで簡単に無料アカウント登録が完了し、</p>
                <p style={{ marginBottom: 0 }}>最短当日からご利用可能。</p>
                <p style={{ margin: 0 }}>面倒な書類手続きはなく、すぐにギフトの手配を始めていただけます。</p>
              </div>
              <a
                href="https://web.catalog.giftmall.co.jp/signup"
                className="flex items-center justify-center transition-all duration-200 px-2 steps:px-6 py-2 steps:py-3 rounded-lg"
                style={{
                  backgroundColor: 'white',
                  boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
                  gap: '2px',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#FFF5F9'
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = 'white'
                }}
              >
                <div className="hidden steps:block" style={{ width: '24px' }} />
                <div className="flex flex-col items-center" style={{ flex: 1, gap: '2px' }}>
                  <div className="flex items-center" style={{ gap: '4px' }}>
                    <div
                      className="hidden steps:block"
                      style={{
                        width: '14px',
                        height: '2px',
                        backgroundColor: '#DA3B78',
                        transform: 'rotate(68deg) scaleY(-1)',
                      }}
                    />
                    <span
                      className="text-[10px] steps:text-xs"
                      style={{
                        fontWeight: 600,
                        letterSpacing: '0.48px',
                        lineHeight: '1.5',
                        color: '#DA3B78',
                        fontFamily: 'Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                      }}
                    >
                      WEB完結で即時発注も可能
                    </span>
                    <div
                      className="hidden steps:block"
                      style={{
                        width: '14px',
                        height: '2px',
                        backgroundColor: '#DA3B78',
                        transform: 'rotate(112deg)',
                      }}
                    />
                  </div>
                  <span
                    className="text-base"
                    style={{
                      fontWeight: 600,
                      letterSpacing: '0.64px',
                      lineHeight: '1.5',
                      color: '#DA3B78',
                      fontFamily: 'Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                      textAlign: 'center',
                    }}
                  >
                    無料アカウント登録
                  </span>
                </div>
                <svg
                  className="w-[18px] h-[18px] steps:w-6 steps:h-6"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <title>矢印アイコン</title>
                  <path
                    d="M9 5L16 12L9 19"
                    stroke="#DA3B78"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </StepCard>
          </div>

          {/* SP用の下向き矢印 1→2 */}
          <div className="flex steps:hidden justify-center">
            <svg
              className="w-8 h-8 rotate-90"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M9 5L16 12L9 19" stroke="#009CD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {/* PC用 Arrow 1: STEP1 → STEP2 */}
          <div className="hidden steps:block steps:absolute" style={{ right: '300px', top: '30px' }}>
            <img
              src="/images/three-steps/step2-arrow.svg"
              alt=""
              aria-hidden="true"
              style={{ width: '281px', height: '147px' }}
            />
          </div>

          {/* STEP2 */}
          <div className="steps:absolute steps:right-0 w-full steps:w-[584px]" style={{ top: '272px' }}>
            <StepCard stepNumber={2} title="カタログギフトの作成" backgroundColor="#EBF7FC" showStepLabel>
              <div className="mb-4 overflow-hidden aspect-[536/409]">
                <img
                  src="/images/three-steps/step2-preview.png"
                  alt="カタログギフト作成画面のプレビュー"
                  className="w-full h-full"
                  style={{ objectFit: 'cover', objectPosition: 'top' }}
                />
              </div>
              <div
                className="text-xs steps:text-base"
                style={{
                  fontWeight: 400,
                  letterSpacing: '0.64px',
                  lineHeight: '1.6',
                  color: '#363636',
                }}
              >
                <p style={{ marginBottom: 0 }}>無料アカウント登録後は、管理画面でカタログギフトづくりが可能に。</p>
                <p style={{ margin: 0 }}>
                  見た目も掲載する商品も自由にカスタマイズして、あなただけの特別なカタログギフトを作ることができます。
                </p>
              </div>
            </StepCard>
          </div>

          {/* SP用の下向き矢印 2→3 */}
          <div className="flex steps:hidden justify-center">
            <svg
              className="w-8 h-8 rotate-90"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M9 5L16 12L9 19" stroke="#009CD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {/* PC用 Arrow 2: STEP2 → STEP3 */}
          <div className="hidden steps:block steps:absolute" style={{ left: '205px', top: '550px' }}>
            <img
              src="/images/three-steps/step1-arrow.svg"
              alt=""
              aria-hidden="true"
              style={{ width: '400px', height: '150px' }}
            />
          </div>

          {/* STEP3 */}
          <div className="steps:absolute steps:left-0 w-full steps:w-[584px]" style={{ top: '776px' }}>
            <StepCard stepNumber={3} title="カタログギフトを贈る" backgroundColor="#EBF7FC" showStepLabel>
              <div
                className="mb-4 text-xs steps:text-base text-left steps:text-center"
                style={{
                  fontWeight: 400,
                  letterSpacing: '0.64px',
                  lineHeight: '1.6',
                  color: '#363636',
                }}
              >
                ギフトの渡し方は用途に応じて自由に選択できます。対面での手渡しや郵送、メールでの送信、SNSやチャットツールでの配信など、贈り先や状況にあわせて最適な方法でお届けできるので、どんなビジネスシーンにも柔軟に対応できます。
              </div>
              <div className="flex gap-2 steps:gap-4">
                <div
                  className="flex flex-col items-center justify-center gap-2 rounded-xl"
                  style={{ flex: 1, backgroundColor: '#FFFFFF', padding: '16px' }}
                >
                  <div
                    className="flex items-center justify-center rounded-full"
                    style={{ backgroundColor: '#EBF7FC', padding: '16px' }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <title>印刷アイコン</title>
                      <path
                        d="M16.25 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V6.66667H17.5V16.25C17.5 16.5815 17.3683 16.8995 17.1339 17.1339C16.8995 17.3683 16.5815 17.5 16.25 17.5Z"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.5 6.66667L10 11.6667L2.5 6.66667"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.5 6.66667V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H16.25C16.5815 2.5 16.8995 2.6317 17.1339 2.86612C17.3683 3.10054 17.5 3.41848 17.5 3.75V6.66667"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span
                    className="text-[10px] steps:text-xs"
                    style={{
                      fontWeight: 400,
                      letterSpacing: '0.48px',
                      lineHeight: '1.6',
                      color: '#363636',
                      fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    }}
                  >
                    印刷して手渡し
                  </span>
                </div>
                <div
                  className="flex flex-col items-center justify-center gap-2 rounded-xl"
                  style={{ flex: 1, backgroundColor: '#FFFFFF', padding: '16px' }}
                >
                  <div
                    className="flex items-center justify-center rounded-full"
                    style={{ backgroundColor: '#EBF7FC', padding: '16px' }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <title>メールアイコン</title>
                      <path
                        d="M2.5 5.83333V15C2.5 15.442 2.67559 15.8659 2.98816 16.1785C3.30072 16.491 3.72464 16.6667 4.16667 16.6667H15.8333C16.2754 16.6667 16.6993 16.491 17.0118 16.1785C17.3244 15.8659 17.5 15.442 17.5 15V5.83333"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.5 5.83333L10 10L2.5 5.83333"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.33333 10L2.5 5.83333V5C2.5 4.55797 2.67559 4.13405 2.98816 3.82149C3.30072 3.50893 3.72464 3.33333 4.16667 3.33333H15.8333C16.2754 3.33333 16.6993 3.50893 17.0118 3.82149C17.3244 4.13405 17.5 4.55797 17.5 5V5.83333L11.6667 10"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span
                    className="text-[10px] steps:text-xs"
                    style={{
                      fontWeight: 400,
                      letterSpacing: '0.48px',
                      lineHeight: '1.6',
                      color: '#363636',
                      fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    }}
                  >
                    メールで一括送付
                  </span>
                </div>
                <div
                  className="flex flex-col items-center justify-center gap-2 rounded-xl"
                  style={{ flex: 1, backgroundColor: '#FFFFFF', padding: '16px' }}
                >
                  <div
                    className="flex items-center justify-center rounded-full"
                    style={{ backgroundColor: '#EBF7FC', padding: '16px' }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <title>ダウンロードアイコン</title>
                      <path
                        d="M10 7.5V11.6667"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.6667 11.6667H3.33333"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10 11.6667L6.66667 8.33333"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10 11.6667L13.3333 8.33333"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.6667 11.6667V15.8333C16.6667 16.0543 16.5789 16.2663 16.4226 16.4226C16.2663 16.5789 16.0543 16.6667 15.8333 16.6667H4.16667C3.94565 16.6667 3.73369 16.5789 3.57741 16.4226C3.42113 16.2663 3.33333 16.0543 3.33333 15.8333V11.6667"
                        stroke="#009CD2"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span
                    className="text-[10px] steps:text-xs"
                    style={{
                      fontWeight: 400,
                      letterSpacing: '0.48px',
                      lineHeight: '1.6',
                      color: '#363636',
                      fontFamily: 'Hiragino Kaku Gothic Std, Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                    }}
                  >
                    コードを一括発行
                  </span>
                </div>
              </div>
            </StepCard>
          </div>
        </div>
      </div>
    </section>
  )
}
